import { MeterStateEnums } from "src/app/enum/meter-enums";

export class MeterModel {
    meterId: number = 0;
    branchId: number = 0;
    consecutive: number = 0;
    startDateMeter: Date = new Date();
    endDateMeter: Date = new Date();
    observation: string | null = null;
    meterState: number = MeterStateEnums.open;
    createDate: Date = new Date();
    userNameCreate: string = '';
    updateDate: Date | null = null;
    userNameUpdate: string | null = null;
}